module.exports = require("@material-ui/icons/AssignmentInd");